import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1698.92308,1772.30769 L1698.92308,1920 L222,1920 L222,1772.30769 L1698.92308,1772.30769 Z M369.692308,0 L369.692308,812.307692 C369.692308,1097.35385 601.569231,1329.23077 886.615385,1329.23077 L886.615385,1329.23077 L1034.30769,1329.23077 C1319.35385,1329.23077 1551.23077,1097.35385 1551.23077,812.307692 L1551.23077,812.307692 L1551.23077,0 L1698.92308,0 L1698.92308,812.307692 C1698.92308,1178.73231 1400.73231,1476.92308 1034.30769,1476.92308 L1034.30769,1476.92308 L886.615385,1476.92308 C520.190769,1476.92308 222,1178.73231 222,812.307692 L222,812.307692 L222,0 L369.692308,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconUnderlineLine = /*#__PURE__*/function (_Component) {
  _inherits(IconUnderlineLine, _Component);

  var _super = _createSuper(IconUnderlineLine);

  function IconUnderlineLine() {
    _classCallCheck(this, IconUnderlineLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconUnderlineLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconUnderline",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconUnderlineLine.displayName = "IconUnderlineLine";
  return IconUnderlineLine;
}(Component);

IconUnderlineLine.glyphName = 'underline';
IconUnderlineLine.variant = 'Line';
IconUnderlineLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconUnderlineLine;
export { IconUnderlineLine };